export const COLORS = {
  brandPrimary: '#6B2F0F',
  brandHover: '#5A2710',
  brandSecondary: '#B78151',

  textPrimary: '#373737',
  textSecondary: '#6b7280',

  backgroundPrimary: '#FBF8F5',
  backgroundLight: '#f9fafb',
  backgroundWhite: '#ffffff',

  accent: '#B78151',

  borderPrimary: '#e0e0e0',

  errorPrimary: '#C4363D',
  errorBackground: '#FFE8E8',

  successPrimary: '#166534',
  successBackground: '#E0F9E9',

  warningPrimary: '#966700',
  warningBackground: '#FFF5CC',

  tabBarActive: '#6B2F0F',
  tabBarInactive: '#6b7280',
  tabBarBorder: '#e0e0e0',

  iconSecondary: '#666666',
  iconPurple: '#9E769C',

  shadowLight: 'rgba(55, 55, 55, 0.3)',
  shadowMedium: 'rgba(55, 55, 55, 0.5)',
  overlayBackground: 'rgba(55, 55, 55, 0.5)',

  ratingActive: '#f59f00',
} as const;

export type ColorKey = keyof typeof COLORS;
